import { Typography, Box } from '@material-ui/core'

import LimitationImage from 'assets/images/pro-update.png'

import { DialogBody } from './DialogBody'

const blue = 'rgba(38, 198, 218, 0.9)'
const blueLight = 'rgba(178, 235, 242, 0.9)'

type Props = {
    planName: string
    isFreePlan: boolean
    onClose: () => void
}

export const ProPlanStartedDialog = ({ planName, onClose, isFreePlan }: Props) => (
    <DialogBody
        isOpen
        onClose={onClose}
        image={LimitationImage}
        bubblesBackground={[blue, blueLight]}
        onPrimaryClick={onClose}
        skipAdmin
        primaryButtonMt={3}
        imageMt={3}
        primaryText="Let's Go"
        title={isFreePlan ? "We'll miss you!" : 'Congrats!'}
        maxTextWidth="350px"
        text={
            <Box mt={3}>
                <Typography>
                    Your account was successfully {isFreePlan ? 'downgraded' : 'upgraded'} to the{' '}
                    <Typography component="span" style={{ fontWeight: 600 }}>
                        {planName}
                    </Typography>{' '}
                    plan
                </Typography>
            </Box>
        }
    />
)
